import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './CompanyDeletePosting.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompanyUpdatesDeleteMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  updateId: Types.Scalars['ID']['input'];
}>;


export type CompanyUpdatesDeleteMutation = (
  { __typename?: 'Mutation' }
  & { companyUpdatesDelete?: Types.Maybe<(
    { __typename?: 'CompanyUpdatesDeleteResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'CompanyUpdatesDeleteError' }
      & Pick<Types.CompanyUpdatesDeleteError, 'message'>
    )> }
  )> }
);


export type CompanyUpdatesDeleteMutationFn = Apollo.MutationFunction<CompanyUpdatesDeleteMutation, CompanyUpdatesDeleteMutationVariables>;

/**
 * __useCompanyUpdatesDeleteMutation__
 *
 * To run a mutation, you first call `useCompanyUpdatesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdatesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdatesDeleteMutation, { data, loading, error }] = useCompanyUpdatesDeleteMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      updateId: // value for 'updateId'
 *   },
 * });
 */
export function useCompanyUpdatesDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CompanyUpdatesDeleteMutation, CompanyUpdatesDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyUpdatesDeleteMutation, CompanyUpdatesDeleteMutationVariables>(Operations.CompanyUpdatesDelete, options);
      }
export type CompanyUpdatesDeleteMutationHookResult = ReturnType<typeof useCompanyUpdatesDeleteMutation>;
export type CompanyUpdatesDeleteMutationResult = Apollo.MutationResult<CompanyUpdatesDeleteMutation>;
export type CompanyUpdatesDeleteMutationOptions = Apollo.BaseMutationOptions<CompanyUpdatesDeleteMutation, CompanyUpdatesDeleteMutationVariables>;